import { render } from "./TicketFormInputs.vue?vue&type=template&id=5310d8be"
import script from "./TicketFormInputs.vue?vue&type=script&lang=js"
export * from "./TicketFormInputs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__